// extracted by mini-css-extract-plugin
export default {"container":"pagination2_container__RmJuB","hidden":"pagination2_hidden__kP4Vm","pageNumber":"pagination2_pageNumber__RVDXQ"};